angular.module('impactx.MenuDirectives').controller('MessageTodoCtrl', ['$scope', 'dataGen', '$mdDialog', '$context', 'MessageService', 'TranslationService', MessageTodoCtrl]);

function MessageTodoCtrl($scope, dataGen, $mdDialog, $context, MessageService, TranslationService) {
    var ctrl = this;
    $scope.getToDoMessageCount = MessageService.getToDoMessageCount;
    this.translationService = TranslationService;

    $scope.$watch(function() {
        return $context.$securityManager.isProcessAllowedWatch;
    }, function(newValue) {
        if(newValue) {
            ctrl.visible = $context.$securityManager.isProcessAllowedWatch($scope, "Message", function(newValue) {
                $scope.visible = newValue
            });
        }
    });
    this.show = function(ev) {
        $mdDialog.show({
            controller: "MessageTodoDialogCtrl",
            templateUrl: 'shared/menu/templates/messagetodo.tmpl.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            hasBackdrop: false,
            disableParentScroll: false
        });

    };
}